import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AUTHORIZATION_HEADER_NAME } from '@app/core/services/auth.constants';
import { AuthService } from '@app/core/services/auth.service';
import { Observable } from 'rxjs';

/**
 * Interceptor to intercept the request and set an authorization token in the headers of the request.
 * */
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    if (token) {
      req = req.clone({
        setHeaders: {
          [AUTHORIZATION_HEADER_NAME]: token
        }
      });
    }

    return next.handle(req);
  }

}
